/**
 * Tipos de Gênero
 */
export enum GenderType {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  NO_ANSWER = 'NO_ANSWER',
}

export const translateGenderType = (status: GenderType | string): string => {
  switch (status) {
    case GenderType.NO_ANSWER:
      return 'Prefiro não informar';
    case GenderType.OTHER:
      return 'Outro';
    case GenderType.FEMALE:
      return 'Feminino';
    case GenderType.MALE:
      return 'Masculino';
    default:
      return status;
  }
};

/**
 * Situacao da conta
 */
export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  DELETED = 'DELETED',
}

export enum PlatformOSType {
  IOS = 'ios',
  ANDROID = 'android',
  MACOS = 'macos',
  WINDOWS = 'windows',
  WEB = 'web',
  NATIVE = 'native',
}

export type Account = {
  uuid: string;
  status: AccountStatus;
  document: string;
  business_unit_uuid: string;
  email: string;
  mobile_number: string;
  first_name: string;
  last_name: string;
  birthdate: string;
  address: {
    line1: string;
    line2: string;
    line3: string;
    neighborhood: string;
    city: string;
    state: string;
    country: string;
    postal_code: string;
  };
  card_number: string;
  gender: GenderType;
  nickname: string;
  language: string;
  last_app_version: string;
  last_app_platform: PlatformOSType;
  blocked_at: string;
  enabled_at: string;
  created_at: string;
  updated_at: string;
  last_access_at: string;
  avatar_url: string;
};
